import React, { useState } from 'react';
import {
    Box,
    TextField,
    Typography,
    Button,
    CircularProgress,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    FormControl
} from '@mui/material';

export const CustomerRegistration = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        address: '',
        dob: '',
        email: '',
        firstName: '',
        gender: '',
        lastName: '',
        panCardNumber: '',
        phoneNumber: '',
        pinCode: '',
        offerLetter: null,
        profilePicUrl: null,
        addressProof: null,
        panCard: null,
        adharCard: null,
        officeId: null,
        salarySlip: null,
        bankStatement: null,
        cibilScore: null,
        latestItr: null,
        incrementLetter: null,
        rentAgreement: null,
        form16: null,
        anyBillCopy: null,
        mandate: null
    });

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle form submission here
        setLoading(false);
    };

    const handleClear = () => {
        setFormData({
            address: '',
            dob: '',
            email: '',
            firstName: '',
            gender: '',
            lastName: '',
            panCardNumber: '',
            phoneNumber: '',
            pinCode: '',
            offerLetter: null,
            profilePicUrl: null,
            addressProof: null,
            panCard: null,
            adharCard: null,
            officeId: null,
            salarySlip: null,
            bankStatement: null,
            cibilScore: null,
            latestItr: null,
            incrementLetter: null,
            rentAgreement: null,
            form16: null,
            anyBillCopy: null,
            mandate: null
        });
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            height="100vh"
            paddingTop="20px"
        >
            <Box
                width="100%"
                maxWidth="600px"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="8px"
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                border="1px solid rgba(0, 0, 0, 0.1)"
            >
                <Typography
                    variant="h5"
                    gutterBottom
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                        color: '#333'
                    }}
                >
                    REGISTRATION
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal" required>
                                <InputLabel>Gender</InputLabel>
                                <Select
                                    name="gender"
                                    value={formData.gender}
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="male">Male</MenuItem>
                                    <MenuItem value="female">Female</MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Date of Birth"
                                name="dob"
                                type="date"
                                value={formData.dob}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Phone Number"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="PAN Card Number"
                                name="panCardNumber"
                                value={formData.panCardNumber}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Address"
                                name="address"
                                value={formData.address}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="PIN Code"
                                name="pinCode"
                                value={formData.pinCode}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                Upload Documents
                            </Typography>
                        </Grid>
                        {[
                            { label: 'Offer Letter', name: 'offerLetter' },
                            { label: 'Profile Picture', name: 'profilePicUrl' },
                            { label: 'Address Proof', name: 'addressProof' },
                            { label: 'PAN Card', name: 'panCard' },
                            { label: 'Aadhaar Card', name: 'adharCard' },
                            { label: 'Office ID', name: 'officeId' },
                            { label: 'Salary Slip', name: 'salarySlip' },
                            { label: 'Bank Statement', name: 'bankStatement' },
                            { label: 'CIBIL Score', name: 'cibilScore' },
                            { label: 'Latest ITR', name: 'latestItr' },
                            {
                                label: 'Increment Letter',
                                name: 'incrementLetter'
                            },
                            { label: 'Rent Agreement', name: 'rentAgreement' },
                            { label: 'Form 16', name: 'form16' },
                            { label: 'Any Bill Copy', name: 'anyBillCopy' },
                            { label: 'Mandate', name: 'mandate' }
                        ].map((doc, index) => (
                            <Grid item xs={12} key={index}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                >
                                    {doc.label}
                                    <input
                                        type="file"
                                        name={doc.name}
                                        onChange={handleInputChange}
                                        hidden
                                    />
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                    <Box display="flex" justifyContent="space-between" mt={4}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleClear}
                            style={{ flexGrow: 1, marginRight: 8 }}
                        >
                            Clear
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            style={{ flexGrow: 1 }}
                        >
                            {loading ? (
                                <CircularProgress size={24} />
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};
